export enum Errors {
  required = 'inputs.errors.required',
}
